import { createAction, props } from '@ngrx/store';
import { KioskMaintenanceDto } from 'src/app/api/models';

export const checkKioskMaintenance = createAction("[Maintenance] Check kiosk maintenance", props<{ kioskId: number }>());
export const checkKioskMaintenanceSuccess = createAction("[Maintenance] Check kiosk maintenance success", props<{ data: KioskMaintenanceDto }>());
export const checkKioskMaintenanceFailure = createAction("[Maintennce] Check kiosk maintenance failure", props<{ error: any }>());

export const checkInsurerMaintenance = createAction("[Maintenance] Check insurer maintenance", props<{ insurerId: string }>());
export const checkInsurerMaintenanceSuccess = createAction("[Maintenance] Check insurer maintenance success", props<{ data: KioskMaintenanceDto }>());
export const checkInsurerMaintenanceFailure = createAction("[Maintennce] Check insurer maintenance failure", props<{ error: any }>());

export const resetMaintenance = createAction("[Maintennce] Reset");